import { render, staticRenderFns } from "./RoomViewMenu.vue?vue&type=template&id=af650606&scoped=true&"
import script from "./RoomViewMenu.vue?vue&type=script&lang=js&"
export * from "./RoomViewMenu.vue?vue&type=script&lang=js&"
import style0 from "./RoomViewMenu.vue?vue&type=style&index=0&id=af650606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af650606",
  null
  
)

export default component.exports